var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1153 972",
    width: 1153,
    height: 972,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Team") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t\t.s0 { opacity: .1;fill: #ffffff } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Team"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lines grid"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line",
    className: "s0",
    d: "m-384 80v-1h1920v1h-1920z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "line",
    className: "s0",
    d: "m-384 848v-1h1920v1h-1920z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "line",
    className: "s0",
    d: "m-384 464v-1h1920v1h-1920z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "line",
    className: "s0",
    d: "m0 0h1v972h-1v-972z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "line",
    className: "s0",
    d: "m384 0h1v972h-1v-972z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "line",
    className: "s0",
    d: "m768 0h1v972h-1v-972z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "line",
    className: "s0",
    d: "m1152 0h1v972h-1v-972z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.02964486a2a1c5751d41053a5e850d96.svg";
export { ForwardRef as ReactComponent };